import React from "react";
import "./index.css";
import Home from './routes/Home';
function App() {
  return (
   <>
   <Home/>
   </>
  );
}

export default App;
